import { PlusCircleFilled } from "@ant-design/icons";
import { Card, Col, message, Row, Select, Typography, Alert } from "antd";
import { Form, Input, Button } from "antd";

import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { GetTokenProducto, TypeIva } from "../../api/utils"; // Removí TypeProduct
import { baseurl, baseurlwc, credentials } from "../../api/api";
import { useProductStore } from "./LayoutProducto";
import { useAttributesStore } from "./Atributes";

const { Option } = Select;

export const ProductoVariante = ({ addProductSimple, variation = false }) => {
  const producto = useProductStore();
  const attributes = useAttributesStore();
  const [form] = Form.useForm();

  const onFinish = (values) => {
    if (variation) {
      addVariante(values);
    } else {
      addProductSimple(values.productstore);
    }

    Form.setFieldsValue({ Codigo: "" });
  };

  toast.configure();

  const onFinishFailed = (errorInfo) => {
    message.info("Por favor complete todos los campos");
  };

  const [termselected, settermselected] = useState({});

  const addVariante = (values) => {
    let productS = {
      ...producto.data,
      IdCategoria: producto.data.IdCategoria,
      IdSubCategoria: producto.data.IdSubCategoria,
      Categoria: producto.data.Categoria,
      SubCategoria: producto.data.SubCategoria,
      PrecioVentaConIva1: values.PrecioVentaConIva1,
      PorcentajeIva: values.PorcentajeIva,
      weight: values.weight,
      TipoProducto: 1,
    };

    productS.Descripcion =
      Cookies.get("productname") + "-" + Object.values(termselected).join("-");

    const getToken = GetTokenProducto(productS);

    toast.promise(getToken, {
      pending: "Obteniendo token...",
      success: "Token obtenido 👌",
      error: "Ocurrio un error ... 🤯",
    });

    getToken.then((token) => {
      let { data } = token;
      if (data) {
        let productotosave = {
          ...productS,
          Token: data,
        };

        toast.info("Guardando producto...", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        axios
          .post(baseurl + "GuardarProducto", {
            ...productotosave,
          })
          .then((res) => {
            if (res.data.Exito) {
              const filteredAttributes = attributes.selected.map((id) => {
                const name = values[`termselected-${id}`];
                const group = attributes.list.filter((i) => i.id === id)[0];
                const att = attributes.groups[id].filter(
                  (i) => i.name === name
                )[0];
                return {
                  id: group.id,
                  option: name,
                  name: group.name,
                  slug: att.slug,
                };
              });

              let producttowc = {
                regular_price: `${productotosave.PrecioVentaConIva1}`,
                price: productotosave.PrecioVentaConIva1,
                manage_stock: true,
                weight: productotosave.weight,
                sku: res.data.CodigoBarras,
                wholesale_price: {
                  wholesale_customer: productotosave.PrecioVentaConIva2,
                },
                attributes: filteredAttributes,
              };

              let idproduct = Cookies.get("productid");
              axios
                .post(
                  `${baseurlwc}/products/${idproduct}/variations?${credentials}`,
                  { ...producttowc }
                )
                .then((res) => {
                  if (res.data.id) {
                    toast.success("Producto guardado con exito");
                  } else {
                    toast.error(
                      "Ocurrio un error al guardar el producto => " +
                        res.data.message
                    );
                  }
                })
                .catch((error) => {
                  toast.error(
                    "Error al guardar la variación: " +
                      error.response?.data?.message || error.message
                  );
                });
            } else {
              toast.error(res.data.MensajeError);
            }
          })
          .catch((error) => {
            toast.error(
              "Error al guardar el producto: " +
                error.response?.data?.message || error.message
            );
          });
      }
    });
  };

  return (
    <Row
      justify="center"
      style={{ margin: "16px 0", maxWidth: "1000px", width: "100%" }}
    >
      <Col xxl={16} xl={18} lg={20} md={22} sm={24} xs={24}>
        <Card
          hoverable
          bordered={false}
          title={
            <Typography.Title level={4} style={{ margin: 0 }}>
              {variation ? "Crear Variante" : "Detalles del producto"}
            </Typography.Title>
          }
          style={{
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
            marginBottom: "24px",
          }}
          bodyStyle={{ padding: "24px" }}
        >
          {variation && (
            <Alert
              message="Puedes crear una o más variantes en este formulario, seleccionando los términos diferentes para cada producto"
              type="info"
              showIcon
              style={{ marginBottom: "24px" }}
            />
          )}

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            initialValues={{
              Codigo: producto.data.Codigo,
              productstore: producto.data.productstore,
              IdCategoria: producto.data.IdCategoria,
              IdSubCategoria: producto.data.IdSubCategoria,
              Descripcion: producto.data.Descripcion,
              PrecioVentaConIva1: producto.data.PrecioVentaConIva,
              PorcentajeIva: producto.data.PorcentajeIva,
              weight: producto.data.weight,
            }}
          >
            <Row gutter={24}>
              <Col xs={24} md={12}>
              {!variation && (
                  <Form.Item
                    label="Nombre producto"
                    name="Descripcion"
                    rules={[
                      {
                        required: true,
                        message: "Digite el nombre del producto",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      disabled={variation}
                      onChange={(value) =>
                        producto.setData({ Descripcion: value.target.value })
                      }
                    />
                  </Form.Item>
                )}
                <Form.Item
                  name="IdCategoria"
                  label="Categoría"
                  rules={[
                    { required: true, message: "Seleccione una categoría" },
                  ]}
                >
                  <Select
                    size="large"
                    onChange={(value) =>
                      producto.setData({
                        IdCategoria: value,
                        Categoria: producto.knowName(value, producto.categorys),
                      })
                    }
                    placeholder="Seleccione una categoría"
                    showSearch
                    optionFilterProp="children"
                  >
                    {producto.categorys.map((category) => (
                      <Option key={category.id} value={category.id}>
                        {category.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="PorcentajeIva"
                  label="Porcentaje IVA"
                  rules={[
                    { required: true, message: "Seleccione un porcentaje IVA" },
                  ]}
                >
                  <Select
                    size="large"
                    onChange={(value) =>
                      producto.setData({ PorcentajeIva: value })
                    }
                    placeholder="Seleccione un porcentaje IVA"
                  >
                    {TypeIva.map((typeiva) => (
                      <Option key={typeiva.Codigo} value={typeiva.Valor}>
                        {typeiva.Descripcion}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
              {!variation && (
              <Form.Item
                  label="Código de referencia"
                  name="Codigo"
                  rules={[
                    {
                      required: true,
                      message: "Digite el código de referencia",
                    },
                  ]}
                >
                  <Input
                    maxLength={45}
                    size="large"
                    onChange={(value) =>
                      producto.setData({ Codigo: value.target.value })
                    }
                  />
                </Form.Item>
                )}
                <Form.Item
                  name="IdSubCategoria"
                  label="Subcategoría"
                  rules={[
                    { required: true, message: "Seleccione una subcategoría" },
                  ]}
                >
                  <Select
                    size="large"
                    onChange={(value) =>
                      producto.setData({
                        IdSubCategoria: value,
                        SubCategoria: producto.knowName(
                          value,
                          producto.categorys
                        ),
                      })
                    }
                    placeholder="Seleccione una subcategoría"
                    showSearch
                    optionFilterProp="children"
                  >
                    {producto.categorys.map((category) => (
                      <Option key={category.id} value={category.id}>
                        {category.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {variation && (
                  <>
                    <Form.Item
                      label="Precio de venta"
                      name="PrecioVentaConIva1"
                      rules={[
                        {
                          required: true,
                          message: "Digite el precio de venta",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        prefix="$"
                        type="number"
                        onChange={(value) =>
                          producto.setData({
                            PrecioVentaConIva1: value.target.value,
                            PrecioVentaConIva2: value.target.value,
                            PrecioVentaConIva3: value.target.value,
                          })
                        }
                      />
                    </Form.Item>
                  </>
                )}
              </Col>
            </Row>

            {variation && (
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="Peso del producto"
                    name="weight"
                    rules={[
                      {
                        required: true,
                        message: "Digite el peso del producto",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Ej: 1 (kg), 300 (gr), 0.3 (otros)"
                      onChange={(value) =>
                        producto.setData({ weight: value.target.value })
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            {!variation
              ? null
              : Object.keys(attributes.data).map((key) => (
                  <Form.Item
                    key={key}
                    name={`termselected-${key}`}
                    label="Seleccione un término"
                    rules={[
                      {
                        required: true,
                        message: "Seleccione un término",
                      },
                    ]}
                  >
                    <Select
                      onChange={(value) => {
                        settermselected((old) => ({ ...old, [key]: value }));
                      }}
                      placeholder="Seleccione un término"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                    >
                      {attributes.data[key].map((termi, index) => (
                        <Option key={index} value={termi}>
                          {termi}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                ))}

            <Form.Item style={{ marginTop: "32px", textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                icon={<PlusCircleFilled />}
                style={{
                  height: "48px",
                  width: variation ? "240px" : "200px",
                  fontSize: "16px",
                  fontWeight: 500,
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                  transition: "all 0.3s",
                }}
              >
                {variation ? "Crear variación" : `Crear ${producto.type}`}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
